import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import api from "../pages/chat/api";

// Returns the current user's permission_role ("Owner" | "Editor" | "Reviewer" |
// "Member") in the active org (selected_org_id), or null while loading / on error.
// Mirrors useIsKbReviewer's data source so role gating stays consistent across the app.
// Fails open (null) on any error, so a transient failure never wrongly locks out a user.
export default function useCurrentOrgRole() {
  const [role, setRole] = useState(null);

  useEffect(() => {
    let active = true;

    const check = async () => {
      try {
        const orgId = Cookies.get("selected_org_id");
        const email = (localStorage.getItem("email") || "").toLowerCase();
        if (!orgId || !email) {
          if (active) setRole(null);
          return;
        }
        const res = await api.get(
          `/api/v1/org/members/list/?organization_id=${orgId}`
        );
        const members = Array.isArray(res.data) ? res.data : [];
        const me = members.find((m) => (m.email || "").toLowerCase() === email);
        if (active) setRole(me?.permission_role || null);
      } catch {
        if (active) setRole(null); // fail open
      }
    };

    check();
    const onWorkspaceChange = () => check();
    window.addEventListener("workspace-changed", onWorkspaceChange);
    return () => {
      active = false;
      window.removeEventListener("workspace-changed", onWorkspaceChange);
    };
  }, []);

  return role;
}
